class HoverCountdown {
  constructor() {
    this.countdowns = window.hoverCountdownDates || [];
    this.intervals = [];
    this.init();
  }

  init() {
    // Clear any existing intervals
    this.intervals.forEach(interval => clearInterval(interval));
    this.intervals = [];

    // Initialize each countdown
    this.countdowns.forEach(countdown => {
      const targetDate = new Date(countdown.date);
      const element = countdown.element;
      
      const daysEl = element.querySelector('[data-days]');
      const hoursEl = element.querySelector('[data-hours]');
      const minutesEl = element.querySelector('[data-minutes]');

      const updateCountdown = () => {
        const now = new Date();
        const diff = targetDate - now;

        if (diff <= 0) {
          // If countdown is finished
          daysEl.textContent = '00';
          hoursEl.textContent = '00';
          minutesEl.textContent = '00';
          return;
        }

        // Calculate remaining time
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

        // Update display with padded numbers
        daysEl.textContent = String(days).padStart(2, '0');
        hoursEl.textContent = String(hours).padStart(2, '0');
        minutesEl.textContent = String(minutes).padStart(2, '0');
      };

      // Initial update
      updateCountdown();

      // Update every minute
      const interval = setInterval(updateCountdown, 60000);
      this.intervals.push(interval);
    });
  }
}

// Initialize countdown when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new HoverCountdown();
});

// Re-initialize when the section is reloaded by Shopify
document.addEventListener('shopify:section:load', () => {
  new HoverCountdown();
}); 